import React from 'react';
import {Toast, ToastPlacement, ToastSkin} from '@wix/wix-ui-tpa';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {classes} from './ErrorToast.st.css';
import {useTranslation} from '@wix/yoshi-flow-editor';

export enum ErrorToastDataHook {
  root = 'ErrorToast.root',
}

export interface ErrorToastParams {
  placement?: ToastPlacement;
}

export const ErrorToast = ({placement = ToastPlacement.inline}: ErrorToastParams) => {
  const {shouldShowError, clearError} = useControllerProps().cartStore;
  const {t} = useTranslation();

  return shouldShowError ? (
    <Toast
      data-hook={ErrorToastDataHook.root}
      skin={ToastSkin.error}
      onClose={() => clearError()}
      className={classes.errorToast}
      placement={placement}
      shouldAnimate
      shouldShowCloseButton>
      {t('sideCart.generalError.toast')}
    </Toast>
  ) : null;
};
